<template>
   <v-container>
    <v-row>
      <v-col cols="3">
        <v-select
          id="taxUnitEditItemFiscalYear"
          class="tax-unit-edit-item-fiscal-year"
          v-model="editedItem.fiscalYear"
          :items="fiscalYearRange"
          label="Fiscal Years"
          readonly
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-text-field
          id="taxUnitEditItemOrderNumber"
          class="tax-unit-edit-item-order-number"
          v-model.number="editedItem.orderNumber"
          v-uppercase=globalSettingItem.conEverythingToCaps
          label="Order Number"
          type="number"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-select
          id="taxUnitEditItemAppSection"
          class="tax-unit-edit-item-app-section"
          v-model="editedItem.appSection"
          :items="sharedBackPageEnum"
          label="App Section"
          item-text="description"
          item-value="name"
        >
        </v-select>
      </v-col>
      <v-col cols="3">
        <v-text-field
          id="taxUnitEditItemSubSection"
          class="tax-unit-edit-item-sub-section"
          v-model="editedItem.subSection"
          v-uppercase=globalSettingItem.conEverythingToCaps
          label="Sub Section"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-text-field
          id="taxUnitEditItemToUnitDescForAppro"
          class="tax-unit-edit-item-to-unit-desc-for-appro"
          v-model="editedItem.toUnitDescForAppro"
          v-uppercase=globalSettingItem.conEverythingToCaps
          label="To Unit in Levy/App"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          id="taxUnitEditItemDescription"
          class="tax-unit-edit-item-description"
          v-model="editedItem.description"
          v-uppercase=globalSettingItem.conEverythingToCaps
          label="Description"
        ></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          id="taxUnitEditItemGeneralLineAt"
          class="tax-unit-edit-item-general-line-at"
          v-model="editedItem.generalLineAt"
          v-uppercase=globalSettingItem.conEverythingToCaps
          label="General Line At"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-text-field
          id="taxUnitEditItemAverageDailyAttendence"
          class="tax-unit-edit-item-average-daily-attendence"
          v-model.number="editedItem.averageDailyAttendence"
          :label="remarkCaption"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          id="taxUnitEditItemInterestSplitPercent"
          class="tax-unit-edit-item-interest-split-percent"
          v-model.number="editedItem.interestSplitPercent"
          label="Interest Split %"
          type="number"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3" v-if="editedItem.appSection === 'B'">
        <v-text-field
          id="taxUnitEditItemMotorVehicle"
          class="tax-unit-edit-item-motor-vehicle"
          v-model.number="editedItem.motorVehicle"
          label="MV"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-checkbox
          id="taxUnitEditItemIsMtgTax"
          class="tax-unit-edit-item-is-mtg-tax"
          v-model="editedItem.isMtgTax"
          label="Mtg Tax"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox
          id="taxUnitEditItemIsMVTS"
          class="tax-unit-edit-item-is-mvts"
          v-model="editedItem.isMVTS"
          label="Motor Vehicle Tax Stamps"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox
          id="taxUnitEditItemIsJt4Mill"
          class="tax-unit-edit-item-is-jt-4-mill"
          v-model="editedItem.isJt4Mill"
          label="JT 4 Mill"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="3" v-if="editedItem.appSection === 'B'">
        <v-checkbox
          id="taxUnitEditItemIsForfeitMV"
          class="tax-unit-edit-item-is-forfeit-mv"
          v-model="editedItem.isMotorVehicleForfeiture"
          label="Forfeit Motor Vehicle"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox
          id="taxUnitEditItemSkipInterest"
          class="tax-unit-edit-item-skip-interest"
          v-model="editedItem.skipInterest"
          label="Skip Interest"
        >
        </v-checkbox>
      </v-col>

    </v-row>
    <v-row>
      <v-col cols="3">
        <v-checkbox
          id="taxUnitEditItemIsPageBreak"
          class="tax-unit-edit-item-is-page-break"
          v-model="editedItem.pageBreakBefore"
          label="Page Break After"
        >
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row>
        <v-col>
          <taxUnitDetails id="taxUnitEditDialogDetails"
            class="tax-unit-edit-dialog-details"
            v-model="editedItem.details"
            :baseCrudKey="baseCrudKey"
          />
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import {
  getFYList,
} from '../../../util/shared/tmc-global';
import taxUnitDetails from './taxUnitDetails.vue';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'taxUnitEditedItem',
  mixins: [GlobalToCaps],
  components: {
    taxUnitDetails,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxUnit-dialog',
    },
  },
  created() {
  },
  computed: {
    ...mapState({
      sharedBackPageEnum: (state) => state.enums.sharedBackPageEnum || [],
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      fiscalYearRange: (state) => {
        const registerdYears = state.shared.taxUnit.regYears || {};
        return getFYList(registerdYears);
      },
    }),
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    remarkCaption() {
      return this.editedItem.appSection === 'B' ? 'ABT' : 'Avg Daily Attendance';
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
  },
};
</script>
